import { render, staticRenderFns } from "./CommunityCards.vue?vue&type=template&id=a2f4caa8&scoped=true&"
import script from "./CommunityCards.vue?vue&type=script&lang=js&"
export * from "./CommunityCards.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCards.vue?vue&type=style&index=0&id=a2f4caa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f4caa8",
  null
  
)

export default component.exports